import React from 'react';
import BaseApi from '../../../api/BaseApi.js';
import ScreenCaption from '../../screen-caption.js';


export default class DonorScreen extends React.Component {

    constructor(props) {
        super(props);

        this.state = {currentDonor: {id: null, 
                                    name: "", 
                                    description: ""}};

        this.handleChangeName = this.handleChangeName.bind(this);  
        this.handleChangeDescription = this.handleChangeDescription.bind(this); 
        this.save = this.save.bind(this);                         
    }

    async componentDidMount() {

        if (this.props.args.donor && this.props.args.donor.length > 0) {
            BaseApi.get("/project/donor", {headers: {
                'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, params: {id: this.props.args.donor}, withCredentials: true})
            .then(res => { 
                this.setState({currentDonor: res.data})
            })    
            .catch()
        }
    }


    save(event) {
        BaseApi.post('project/donor', this.state.currentDonor, {headers: {
            'Content-Type': 'application/json', 'SESSIONID' : sessionStorage.getItem("session")}, withCredentials: true})
        .then(res => {
            var currentDonor = this.state.currentDonor
            currentDonor.id = res.data.id
            this.setState({currentDonor: currentDonor})
            this.props.args.donor = res.data.id
        })
        .catch(error=>console.log(error))
        
        event.preventDefault();
    }

    handleChangeName(event) {
        var currentDonor = this.state.currentDonor
        currentDonor.name = event.target.value
        this.setState({currentDonor: currentDonor})
    }

    handleChangeDescription(event) {
        var currentDonor = this.state.currentDonor
        currentDonor.description = event.target.value
        this.setState({currentDonor: currentDonor})
    }

    /*
    openEvents() {
        this.props.navigate("events", 
        {caller: "donor", callargs: this.props.args, donorid: this.state.currentDonor.id})

    }

    openProducts() {
        this.props.navigate("products", 
        {caller: "donor", callargs: this.props.args, donorid: this.state.currentDonor.id})

    }

    opendonorContracts() {
        this.props.navigate("contract-donors", 
        {caller: "donor", callargs: this.props.args, donorid: this.state.currentDonor.id, caption: "Контракты", donor: this.state.currentDonor})

    }

    openRefs() {
        this.props.navigate("refs", 
        {caller: "donor", callargs: this.props.args, refrecid: this.state.currentDonor.id})    
    }

    */
    render() {
        const donorExists = !!this.state.currentDonor.id;
    
        return (
            <div class="container">
                <ScreenCaption goback={this.props.goback} args={this.props.args} caption={"Источники финансирования"}/>
                <div className="row mt-4">
                    <div className="col-lg-8">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">
                                    {donorExists ? "Редактирование источника" : "Новый источник"}
                                </h6>
                                <form>
                                    <div class="form-group">
                                        <label for="name"> Наименование:</label>
                                        <input type="text" class="form-control w-100" id="name" value={this.state.currentDonor.name} onChange={this.handleChangeName} />
                                        <label for="description">Описание:</label>
                                        <input type="text" class="form-control w-100" id="description"  value={this.state.currentDonor.description} onChange={this.handleChangeDescription} />
                                        <div className="mt-4 d-flex justify-content-end">
                                            <div class="row mt-3">
                                                <button class="btn btn-primary w-100" onClick={this.save}>Сохранить</button>   
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 mt-4 mt-lg-0">
                        <div className="card shadow-sm">
                            <div className="card-body">
                                <h6 className="card-title mb-3">Действия</h6>

                                {/*
                                {donorExists && (
                                    <div>
                                        <button 
                                            className="btn btn-outline-primary w-100 mb-2" 
                                            onClick={()=>{this.openEvents()}}>
                                                События
                                        </button>      
                                        <button 
                                            className="btn btn-outline-primary w-100 mb-2"
                                            onClick={()=>{this.openProducts()}}>
                                                Продукты
                                        </button>                             
                                        <button 
                                            className="btn btn-outline-primary w-100 mb-2"
                                            onClick={()=>{this.opendonorContracts()}}>
                                                Контракты
                                        </button>   
                                        <button 
                                             className="btn btn-outline-primary w-100 mb-2"
                                            onClick={()=>{this.openRefs()}}>
                                                Ссылки
                                        </button>   
                            
                                    </div>
                                )}
                                */}    
                                {!donorExists && (
                                    <p className="text-muted mb-0">
                                    Дополнительные действия станут доступны после сохранения записи.
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
        )
    }

}


// WEBPACK FOOTER //
// ./src/ui/workspace-screens/project/donor.js